<!--お仕事詳細-->
<template>
  <div>
    <!-- 基本情報 -->
    <div style="margin-top:5px">
      <!-- 表头文字 -->
      <el-row :gutter="0" style="background-color:#3cc6fa;">
        <div class="table-header">{{$t('MODULE.I0019_LBL_DETAIL_TITLE')}}</div>
      </el-row>
      <table class="i0019-table table-label">
        <!-- 作業日 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL1')}}</td>
          <td class="i0019-form-value">{{this.$route.query.jobDate}}</td>
        </tr>
        <!-- 店舗 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL2')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.storeName}}</td>
        </tr>
        <!-- 作業場所 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0019_LBL_WORK_AREA')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.workPlace}}</td>
        </tr>
        <!-- お仕事内容 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL4')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.jobContent}}</td>
        </tr>
        <!-- 作業期間 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0019_LBL_WORK_DATE')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.startDate}}～{{this.detailInfo.endDate}}</td>
        </tr>
        <!-- 開始時刻 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL5')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.startTime}}</td>
        </tr>
        <!-- 終了時刻 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL6')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.endTime}}</td>
        </tr>
        <!-- 勤務時間 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL8')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.workTime}}</td>
        </tr>
        <!-- 休憩時間 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL7')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.breakTime}}</td>
        </tr>
        <!-- 時給単価 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL9')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.restTime}}</td>
        </tr>
        <!-- 交通費 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0019_LBL_TRAFFIC_COST')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.transportExpenses}}</td>
        </tr>
        <!-- 集合場所 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL12')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.gatherPlace}}</td>
        </tr>
        <!-- 集合時間 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL13')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.gatherTime}}</td>
        </tr>
        <!-- 備考 -->
        <tr>
          <td class="i0019-form-label">{{$t('MODULE.I0018_LBL_COL15')}}</td>
          <td class="i0019-form-value">{{this.detailInfo.note}}</td>
        </tr>
      </table>
      <!-- 申请按钮 -->
      <div style="text-align:center">
        <el-button class="css-btn css-button" style="margin-top: 8px;width:120px;" @click="job_apply()">{{$t('MODULE.K0011_LBL_MSG7')}}</el-button>
        <el-button class="css-btn css-button" style="margin-top: 8px;width:120px;" @click="ret_click()">{{$t('MODULE.I0018_LBL_BTN2')}}</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import * as amsApi from "../api/i_0017"
import css from "@/statics/css"
let url = require('@/../config/sysConfig')
export default {
  mixins: [css],
  data() {
    return {
      detailInfo: [],
    }
  },
  created() {
    this.userCd = JSON.parse(localStorage.getItem('userInfo')).userCd;
    //検索
    this.query();
  },
  methods: {
    // 検索
    query() {
      // loading处理
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 検索処理
      amsApi.i_0017_detail_search(this.$route.query.fieldCd, this.$route.query.recruitNo).then(res => {
        if (res.code === 300) {
          this.loading.close();
          return
        } else if (res.code === 204) {
          this.detailInfo = res.items.jobDetailInfoList[0]
        }
        this.loading.close();
      }).catch(() => {
        this.loading.close();
      });
    },
    // キャンセル
    ret_click() {
      this.$router.push({ path: url.routerUrl_I0018, query: { jobDate: this.$route.query.jobDate } })
    },
    job_apply() {
      if (this.$route.query.editShow) {
        this.$message.warning({ message: this.$t('COMMON.MSG_JOB_ALREADY_APPLY'), showClose: true })
        return
      }
      this.$router.push({ path: url.routerUrl_I0020, query: { editShow: this.$route.query.editShow, jobDate: this.$route.query.jobDate, recruitNo: this.$route.query.recruitNo, fieldCd: this.$route.query.fieldCd } })
    }
  }
}
</script>
<style>
/* 表格边框、字体样式 */
.i0019-table {
  border-collapse: collapse;
  width: 100%;
}
/* 表格边框颜色 */
.i0019-table,
.i0019-table tr td {
  border: 1px solid #ccc;
}
.i0019-form-value,
.i0019-form-value tr td {
  padding-right: 0 !important;
}
/* 表格内边距 */
.i0019-table td {
  padding: 5px 8px;
}
/* 表格第一列背景色、宽度、文字居右 */
.i0019-form-label {
  text-align: right;
  width: 80px;
  background: #d2eef8;
}
/* 表格第二列背景色 */
.i0019-form-value {
  background: #fafafa;
}
.i0019-form-value .el-button--small,
.el-button--small.is-round {
  padding-left: 9px;
  padding-right: 9px;
}
/* 按钮样式 */
.i0019-css-btn {
  color: #fff;
  margin-top: 15px;
  width: 20%;
  height: 40px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0019-css-btn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}
/*按钮激活和焦点样式*/
.i0019-css-btn:active,
.i0019-css-btn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
/* 按钮样式 */
.i0019-css-addressbtn {
  color: #fff;
  width: 20%;
  height: 100%;
  padding-left: 15px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
}
/*按钮经过样式*/
.i0019-css-addressbtn:hover {
  color: #fff;
  background-image: linear-gradient(0deg, #0f91c2, #41bae6);
}
/*按钮激活和焦点样式*/
.i0019-css-addressbtn:active,
.i0019-css-addressbtn:focus {
  color: #fff;
  background-image: linear-gradient(0deg, #29a8d8, #29a8d8);
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0019.vue